import React, { useState, useEffect } from 'react';
import { getRestaurantInfo, getChefInfo } from '../services/api';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const About = () => {
  const [restaurantInfo, setRestaurantInfo] = useState(null);
  const [chefInfo, setChefInfo] = useState(null);

  useEffect(() => {
    // Load data from API
    const fetchData = async () => {
      try {
        const [infoRes, chefRes] = await Promise.all([
          getRestaurantInfo(),
          getChefInfo()
        ]);
        setRestaurantInfo(infoRes);
        setChefInfo(chefRes);
      } catch (error) {
        console.error('Error fetching data:', error);
        // Fallback to localStorage
        const savedInfo = localStorage.getItem('restaurantInfo');
        const savedChef = localStorage.getItem('chefInfo');
        if (savedInfo) setRestaurantInfo(JSON.parse(savedInfo));
        if (savedChef) setChefInfo(JSON.parse(savedChef));
      }
    };
    fetchData();
  }, []);

  if (!restaurantInfo || !chefInfo) return null;

  return (
    <section id="about" className="py-24 px-4" style={{ backgroundColor: '#FFCCE0' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2
            className="md:text-6xl !font-bold !text-5xl mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}>Quiénes somos


          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            {restaurantInfo.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Chef Image */}
          <div className="order-2 md:order-1">
            <img
              src={chefInfo.image}
              alt={chefInfo.name}
              className="w-full h-[500px] object-cover rounded-xl shadow-lg"
              style={{ objectPosition: 'center top' }} />

          </div>

          {/* Chef Info */}
          <div className="order-1 md:order-2">
            <Card className="bg-white/80 backdrop-blur-sm border-none shadow-md">
              <CardContent className="p-8">
                <h3
                  className="text-4xl font-bold mb-2"
                  style={{ fontFamily: "'Crimson Text', serif" }}>

                  {chefInfo.name}
                </h3>
                <p className="text-xl text-gray-600 mb-6">{chefInfo.title}</p>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {chefInfo.bio}
                </p>
                <div>
                  <h4 className="!font-semibold !text-lg mb-3">Especialidades:</h4>
                  <div className="flex flex-wrap gap-2">
                    {chefInfo.specialties.map((specialty) =>
                    <Badge
                      key={specialty}
                      variant="secondary"
                      className="bg-black text-white px-4 py-2 text-sm">

                        {specialty}
                      </Badge>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>);

};

export default About;